import { Injectable, inject } from '@angular/core';
import { ContentAsset, Play } from '@r1-compass-library/models';
import { Dependency } from '@r1-compass-library/models/dependencies.model';
import { PlayService } from '@r1-compass-library/services';
import { ContentAssetService } from '@r1-compass-library/services/content-asset.service';
import { ContentAssetFolderService } from '@r1-compass-library/services/content-asset-folder.service';
import { AssetListState, AssetListStore } from '@r1-compass-library/store/asset-list.store';
import { forkJoin } from 'rxjs';

@Injectable()
export class ContentAssetListStore extends AssetListStore<
    ContentAsset,
    ContentAssetService,
    ContentAssetFolderService
> {
    readonly #playService = inject(PlayService);

    protected override initialState: AssetListState<ContentAsset> = {
        assets: [],
        folders: [],
        currentFolder: null,
        message: undefined,
    };

    assetTypeName = 'Content Asset Folder';

    constructor(assetRestService: ContentAssetService, folderRestService: ContentAssetFolderService) {
        super(assetRestService, folderRestService);
    }

    protected override handleDependencies(assets: ContentAsset[]) {
        this.clearDependencies();
        forkJoin(assets.map(asset => this.#playService.search({ contentAssetId: asset.id }))).subscribe(plays => {
            this.setDependenciesForAssets(plays, assets);
        });
    }

    protected override buildDependencies(play: Play, assets: ContentAsset[]): Dependency[] {
        const dependencies: Dependency[] = [];
        play.config?.talkingPointsDefinition?.contentAssets.forEach(contentAsset => {
            dependencies.push({
                assetId: contentAsset.id,
                playId: play.id,
                name: play.name,
            });
        });
        return dependencies;
    }
}
